import { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../context/ApplicationContext";
import { Button, Card, CardHeader, Form, Modal } from "react-bootstrap";
import { IProduct } from "../../types/IProduct";
import { IReceiptRow } from "../../types/IReceiptRow";
import { generateGUID } from "../../helpers/Helper";

export interface IDiscountProps {
  close(): void;
  show: boolean;
}

export const DiscountModal: React.FC<IDiscountProps> = (
  props: IDiscountProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [payValue, setPayValue] = useState("");
  const [typeOfDiscount, setTypeOfDiscount] = useState("%");
  const [afterDiscount, setAfterDiscount] = useState("");

  const buttonStyle = {
    width: "15vh",
    height: "10vh",
    fontSize: "4vh",
    fontWeight: "bolder",
    maxWidth: "100px",
    maxHeight: "100px",
    padding: 0,
  };

  function appendChar(value: string) {
    let v = payValue;
    v = v + value;
    setPayValue(v);
  }

  useEffect(() => {
    updatePricing();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payValue, typeOfDiscount]);

  function deleteLastChar() {
    const v = payValue;
    const newValue = v.substring(0, v.length - 1);
    setPayValue(newValue);
  }

  function updatePricing() {
    const value = payValue;

    if (typeOfDiscount === "%") {
      const removeValue = (Number(value) / 100) * getTotal();
      const newValue = getTotal() - removeValue;
      setAfterDiscount(newValue.toFixed(2));
      return;
    }

    const newValue = getTotal() - Number(value);
    setAfterDiscount(newValue.toFixed(2));

    // if (isNaN(value)) {
    //   setToPayType("Amount Due");
    //   setPayRemaining(getTotal().toFixed(2));
    //   return;
    // }

    // if (value < total) {
    //   const remainingValue = total - value;
    //   setPayRemaining(remainingValue.toFixed(2));
    //   return;
    // }

    // setToPayType("Change");
    // const change = total - value;
    // setPayRemaining((change * -1).toFixed(2));
  }

  function percentageVariant() {
    if (typeOfDiscount === "%") {
      return (
        <Button
          variant="info"
          style={{ width: 60 }}
          onClick={() => setTypeOfDiscount("%")}
        >
          %
        </Button>
      );
    }

    return (
      <Button
        variant="secondary"
        style={{ width: 60 }}
        onClick={() => setTypeOfDiscount("%")}
      >
        %
      </Button>
    );
  }

  function priceVariant() {
    if (typeOfDiscount === "£") {
      return (
        <Button
          variant="info"
          style={{ width: 60 }}
          onClick={() => setTypeOfDiscount("£")}
        >
          £
        </Button>
      );
    }

    return (
      <Button
        variant="secondary"
        style={{ width: 60 }}
        onClick={() => setTypeOfDiscount("£")}
      >
        £
      </Button>
    );
  }

  function getTotal() {
    let total = 0;
    context.Receipt.getRows().forEach((r) => {
      total += r.qty * r.price;
    });
    return total;
  }

  const layout = () => (
    <>
      <>
        <div
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div>
            <table>
              <tr>
                <td
                  style={{
                    width: 150,
                    backgroundColor: "whitesmoke",
                    verticalAlign: "top",
                    padding: 10,
                  }}
                >
                  {percentageVariant()} {priceVariant()}
                  total:
                  <h1>
                    <div>£{getTotal().toFixed(2)}</div>
                  </h1>
                  after:
                  <h1>
                    <div>£{afterDiscount}</div>
                  </h1>
                </td>
                <td style={{ width: 5, backgroundColor: "white" }}></td>
                <td>
                  <table>
                    <tr>
                      <td colSpan={4} style={{ backgroundColor: "" }}>
                        <input
                          placeholder="£"
                          aria-label="£"
                          aria-describedby="basic-addon1"
                          style={{
                            fontSize: "25px",
                            width: "40vw",
                            maxWidth: "400px",
                          }}
                          value={typeOfDiscount + payValue}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("7")}
                        >
                          7
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("8")}
                        >
                          8
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("9")}
                        >
                          9
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("5.00")}
                        >
                          £5
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("4")}
                        >
                          4
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("5")}
                        >
                          5
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("6")}
                        >
                          6
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("10.00")}
                        >
                          £10
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("1")}
                        >
                          1
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("2")}
                        >
                          2
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("3")}
                        >
                          3
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("20.00")}
                        >
                          £20
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("0")}
                        >
                          0
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar(".")}
                        >
                          .
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => deleteLastChar()}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            fill="currentColor"
                            className="bi bi-backspace"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.83 5.146a.5.5 0 0 0 0 .708L7.975 8l-2.147 2.146a.5.5 0 0 0 .707.708l2.147-2.147 2.146 2.147a.5.5 0 0 0 .707-.708L9.39 8l2.146-2.146a.5.5 0 0 0-.707-.708L8.683 7.293 6.536 5.146a.5.5 0 0 0-.707 0z" />
                            <path d="M13.683 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7.08a2 2 0 0 1-1.519-.698L.241 8.65a1 1 0 0 1 0-1.302L5.084 1.7A2 2 0 0 1 6.603 1zm-7.08 1a1 1 0 0 0-.76.35L1 8l4.844 5.65a1 1 0 0 0 .759.35h7.08a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                          </svg>
                        </Button>
                      </td>
                      <td>
                        <Button variant="outline-primary" style={buttonStyle}>
                          £0
                        </Button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </>
    </>
  );

  const discountModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Discount</Modal.Title>
          </Modal.Header>
          <Modal.Body>{layout()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="primary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => setPayValue("")}
              >
                Clear
              </Button>
            </div>
            <div>
              <Button
                variant="primary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => close()}
              >
                Cancel
              </Button>
            </div>
            <Button
              variant="warning"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => addDiscount()}
            >
              Add discount
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  function close() {
    setPayValue("");
    setAfterDiscount("");

    props.close();
  }

  function addDiscount() {
    const product: IProduct = {
      id: 0,
      uuid: generateGUID(),
      parentId: 0,
      description: "Discount (" + typeOfDiscount + payValue + ")",
      imageUrl: "",
      position: 0,
      isCategory: false,
      price: (getTotal() - Number(afterDiscount)) * -1,
      qty: 1,
      textColour: "",
      buttonColour: "",
      zone: 0,
      barcode: "",
    };

    const receiptRow: IReceiptRow = {
      id: context.Receipt.getRows().length + 1,
      product: product,
      variations: [],
      extras: [],
      commonOptions: [],
      notes: "",
      instructions: [],
      description: [],
      price: product.price,
      qty: 1,
      isDiscount: true,
      options: [],
      uuid: generateGUID(),
    };
    context.Receipt.addRow(receiptRow);

    //apply the discount

    close();
  }

  return <>{discountModal()}</>;
};
